import { defineStore } from "pinia"

export const useStoryRingStore = defineStore("storyRings", {
  state: () => ({
    // Plain objects used instead of Set — Vue 3 reactive object replacement
    // is rock-solid and works reliably after SSR hydration; Set.has() tracking
    // is flaky post-hydration.
    unviewedCreatorIds: {} as Record<string, true>,
    activeStoryCreatorIds: {} as Record<string, true>,
    lastFetchedAt: null as Date | null,
    isFetching: false,
  }),

  getters: {
    hasUnviewed: (state) => (creatorId: string) =>
      !!state.unviewedCreatorIds[creatorId],
    hasActiveStory: (state) => (creatorId: string) =>
      !!state.activeStoryCreatorIds[creatorId],
  },

  actions: {
    async fetch(apiUrl: string, token: string) {
      if (this.isFetching) return
      this.isFetching = true
      try {
        const data = await $fetch<{
          feed?: Array<{
            creator?: { id?: string | number }
            hasUnviewed?: boolean
          }>
        }>(`${apiUrl}/api/stories/feed`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        })
        const unviewed: Record<string, true> = {}
        const active: Record<string, true> = {}
        if (data?.feed) {
          for (const item of data.feed) {
            const id = String(item.creator?.id ?? "")
            if (!id) continue
            active[id] = true
            if (item.hasUnviewed) unviewed[id] = true
          }
        }
        // Replace entire objects — triggers Vue reactive property change
        this.unviewedCreatorIds = unviewed
        this.activeStoryCreatorIds = active
        this.lastFetchedAt = new Date()
      } catch (e) {
        console.error("[StoryRings] fetch failed:", e)
      } finally {
        this.isFetching = false
      }
    },

    markViewed(creatorId: string) {
      const { [creatorId]: _, ...rest } = this.unviewedCreatorIds
      this.unviewedCreatorIds = rest
    },

    clear() {
      this.unviewedCreatorIds = {}
      this.activeStoryCreatorIds = {}
      this.lastFetchedAt = null
    },
  },
})
